var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ma-2",attrs:{"loading":_vm.downloadingXls,"tile":"","outlined":"","color":"success"},on:{"click":_vm.downloadXls}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-download")]),_vm._v(" Baixar xls ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }